import { Component, Inject } from "@angular/core";

import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";

import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";
import { IBillingShippingModel } from "../../../../interfaces/LicenseModel";
import Swal from "sweetalert2";

@Component({
  template: require('./renew-syncit-licence.component.html'),
  styles: [require('./renew-syncit-licence.component.css')],
  selector: "renew-syncit-license",
})
export class RenewSyncItComponent {
  SyncITProductLicenseId: any;
  SyncItExtendRenewForm: FormGroup;
  dialogTitle = "Extend Trial Period";
  billingShippingDetail: IBillingShippingModel = {
    ODataEtag: "",
    Number: "",
    publicId: "",
    CustomerNo: "",
    publicSalesPersoncode: "",
    BillToName: "",
    BillToAddress1: "",
    BillToAddress2: "",
    BillToCity: "",
    BillToState: "",
    BillToZipcode: "",
    BillToCountryCode: "",
    ShipToCode: "",
    ShipToName: "",
    ShipToAddress1: "",
    ShipToAddress2: "",
    ShipToCity: "",
    ShipToState: "",
    ShipToZipcode: "",
    ShipToCountryCode: "",
    CustomerTelephone: "",
    CustomerEmailAddress: "",
    CustomerFaxno: "",
    ShippingTelephoneno: "",
    ShippingFaxno: "",
    ShippingEmailAddress: "",
    Rep1: "",
    Rep2: "",
    Sales1: "",
    Sales2: "",
  };
  error = "";
  isLoading = false;
  syncItproductList: any;
  prevSalesOrderNo = "";
  customerId = 0;
  shippingAddressId = 0;
  shouldFetchSalesOrderNo = false;

  isBillingShippingDetailFetched = false;

  errorMessage = "";
  constructor(
    private licenseService: LicenseService,
    private dialogRef: MdDialogRef<RenewSyncItComponent>,
    private adalService: AdalService,
    private router: Router,
    private formBuilder: FormBuilder,
    private snackBar: MdSnackBar,
    private appLoader: AppLoaderService,
    @Inject(MD_DIALOG_DATA) public dialogData: any
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.SyncITProductLicenseId = dialogData.payload.SyncITProductLicenseId;
    this.buildForm();
  }
  buildForm() {
    this.SyncItExtendRenewForm = this.formBuilder.group({
      NoOfMonths: ["", Validators.required],
      SalesOrderNo: ["", Validators.required],
    });
  }
  onSave() {
    if (this.SyncItExtendRenewForm.valid) {
      this.appLoader.open();
      const formValue = this.SyncItExtendRenewForm.getRawValue();
      this.licenseService
        .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
        .subscribe((data) => {
          if (!data.IsError && data.DataObject != null) {
            let model = {
              CustomerId: data.DataObject.CustomerId,
              ShippingAddressId: data.DataObject.ShippingAddressId,
              UpdatedBy: Number(localStorage.getItem("userid")),
              SyncITProductLicenseId: this.SyncITProductLicenseId,
              NoOfMonths: this.SyncItExtendRenewForm.value.NoOfMonths,
              SalesOrderNo: this.SyncItExtendRenewForm.value.SalesOrderNo,
            };
           this.dialogRef.close(model);
          }
        });
    }
  }
  getBillingShippingDetail() {
    let salesOrderNo = this.SyncItExtendRenewForm.value.SalesOrderNo;
    if (salesOrderNo != "") {
      if (this.shouldFetchSalesOrderNo) {
        this.appLoader.open();
        this.licenseService
          .getBillingShippingDetail(salesOrderNo)
          .subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
              this.billingShippingDetail = data.DataObject;
              this.isBillingShippingDetailFetched = true;
              this.error = "";
            } else {
              this.isBillingShippingDetailFetched = false;
              this.error = data.Error;
            }
            this.appLoader.close();
          });
      } else {
        this.error = "Please select other sales order number.";
      }
    } else {
      this.error = "Sales Order No is required";
      this.isBillingShippingDetailFetched = false;
    }
  }

  checkSalesOrderNo() {
    if (this.dialogData.SyncItLicenseList) {
      let exist = this.dialogData.SyncItLicenseList.some((element) => {
        if (element.SalesOrderNo != null) {
          return (
            this.SyncItExtendRenewForm.value.SalesOrderNo.trim().toUpperCase() ==
            element.SalesOrderNo.trim().toUpperCase()
          );
        } else {
          return false;
        }
      });

      if (exist) {
        Swal.fire({
          title: "This sales order no already exists",
          text: "Are you sure you want to use this Sales Order No?",
          showCancelButton: true,
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          confirmButtonColor: "#FFCA28",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
          } else {
            this.shouldFetchSalesOrderNo = false;
            this.SyncItExtendRenewForm.patchValue({
              SalesOrderNo: "",
            });
          }
        });
      } else {
        this.shouldFetchSalesOrderNo = true;
        this.isBillingShippingDetailFetched = false;
        this.getBillingShippingDetail();
      }
    } else {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
      this.getBillingShippingDetail();
    }
  }

  blurSalesOrderEvent() {
    if (
      this.prevSalesOrderNo.trim().toUpperCase() ==
      this.SyncItExtendRenewForm.value.SalesOrderNo.trim().toUpperCase()
    ) {
      return;
    }
    this.prevSalesOrderNo = this.SyncItExtendRenewForm.value.SalesOrderNo;
    setTimeout(() => {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
    }, 150);
  }
  onCancel() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/popup/renew-syncit-license/renew-syncit-license.component.ts